// extracted by mini-css-extract-plugin
module.exports = {"nav":"MainNavigation_nav__RU3Su","navList":"MainNavigation_navList__6fZvf","navItem":"MainNavigation_navItem__sn0Hj","navItemLinkIcon":"MainNavigation_navItemLinkIcon__ggQiZ"};